import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { noteChangePriceModalResourceType } from "../../configs/note-change-price-config";
import { FormGroup, ReactiveFormsModule } from "@angular/forms";
import { NoteChangePriceFormField } from "../../types/note-change-price.types";
import { RecordUpdateRequestParams } from "../../../../../../../../core/types/records-table.types";
import { noteChangePriceRows } from "../../configs/note-change-price-rows";
import { noteChangePriceCreateFields, noteChangePriceEditFields } from "../../configs/note-change-price-fields";
import { MatFormField, MatInput, MatLabel } from "@angular/material/input";
import { CdkTextareaAutosize } from "@angular/cdk/text-field";

@Component({
  selector: 'app-note-change-price-form',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    MatFormField,
    MatLabel,
    MatInput,
    CdkTextareaAutosize
  ],
  templateUrl: './note-change-price-form.component.html',
  styleUrl: './note-change-price-form.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class NoteChangePriceFormComponent {
  noteChangePriceId = input.required<number>();
  noteChangePriceFormGroup = input.required<FormGroup>();
  isValid = input.required<boolean>();
  isEditModeActive = input.required<boolean>();
  updateField = output<RecordUpdateRequestParams>();

  public readonly noteChangePriceRows = noteChangePriceRows;

  public getFormFields(rowKey: string): Array<NoteChangePriceFormField> {
    const fields = this.isValid() ? noteChangePriceEditFields : noteChangePriceCreateFields;
    return fields.filter(field => field.rowKey === rowKey);
  }

  public getClassField(field: NoteChangePriceFormField): string {
    if (field.noEdit) { return 'none-pointer-events'; }
    if (!this.isValid()) { return ''; }

    return this.isEditModeActive() ? '' : 'none-pointer-events';
  }

  public getRowClass(key: string): string {
    if (key === 'advertisementBudget') { return 'form-row-two-item'; }
    if (key === 'comment') { return 'form-row-full'; }

    return '';

  }

  public getFieldLabel(field: NoteChangePriceFormField): string {
    return field.shortLabel || field.label;
  }

  public async handleUpdateField(fieldName: string): Promise<void> {
    if (!this.isValid()) { return; }

    const updateRequestParams: RecordUpdateRequestParams = {
      path: noteChangePriceModalResourceType.path,
      recordId: this.noteChangePriceId(),
      fieldName: fieldName,
      value: this.noteChangePriceFormGroup().get(fieldName)?.value
    };

    this.updateField.emit(updateRequestParams);
  }
}
